import styled from "styled-components";
import { useRef } from "react";
import EmailEditor from "react-email-editor";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";

const EditorWrap = styled.div`
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};

  flex: 1;

  @media (max-width: ${globalConstants.switchTablet}) {
    padding: 0 8px;
  }
`;

const EditorBorderWrap = styled.div`
  border-radius: ${css.BOX_RADIUS_SECONDARY};
  overflow: hidden;

  display: flex;

  flex: 1;
`;

const EditorControls = styled.div`
  display: flex;
`;

export default ({ emailEditorRef, saveMessage, onEditorReady }) => {
  return (
    <EditorWrap>
      <EditorBorderWrap>
        <EmailEditor ref={emailEditorRef} onReady={onEditorReady} />
      </EditorBorderWrap>
      <EditorControls>
        <ButtonPrimarySmall onClick={saveMessage}>Save</ButtonPrimarySmall>
      </EditorControls>
    </EditorWrap>
  );
};
